import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Message, SelectItem } from "primeng/components/common/api";
import { AppConstants } from "../core/app.constants";
import { AuthAccessProvider } from "../core/core.auth";
import { BaseComponent, Offer, Client, Scadenza, User, UserContext, UserInfo } from "../core/core.component";
import { BusyProvider } from "../service/busy.service";
import { MessageProvider } from "../service/message.service";
import { UserService } from "../service/user.service";
import { OfferService } from "app/service/offers.service";
import { ClientService } from "app/service/clients.service";
import { ScadenzeFatturazioneService } from "app/service/scadenze.service";
import { Observable } from "rxjs";

@Component({
	selector: "app-offers",
	templateUrl: "./offers.component.html",
	styleUrls: ["./offers.component.css"],
})
export class OffersComponent extends BaseComponent implements OnInit {
	offers: Offer[] = [];
	userContext: UserContext | null = null;
	userInfo: UserInfo = new UserInfo();

	locale: any = AppConstants.ITA_CALENDAR_CONF;
	users: SelectItem[] = [];
	utentiAggiunti: number[] = [];				//Utenti associati all'offerta
	filteredUsers: SelectItem[] = [];
	offerteUtenti: SelectItem[] = [];
	filterTipologia: string | null = null;
	filterCliente: string | null = null;
	filterDtinizio: Date | null = null;
	filterDtfine: Date | null = null;
	filterId: number | null = null;
	filterUser: number | null = null;
	filterRefOrder: string | null = null;
	filterDora: string | null = null;
	filterTipoServ: string | null = null;
	filterQuery: string = "";
	clients: Client[] = [];
	onlyActive: boolean = true;
	loading: boolean = false;
	offerSelected: Offer = new Offer();
	nascondiImporto: boolean = true;
	validationMessage: string | null = null;
	validationMessageScadenzaAlert: string | null = null;
	generaScadenzeErrorMessage: string | null = null;
	showDeleteAlert: boolean = false;
	showDeleteUserAlert: boolean = false;
	showGeneraScadenzeErrorDialog: boolean = false;
	showGeneraScadenzaAlert: boolean = false;
	showUsersDialog: boolean = false;
	showFilter: boolean = false;
	showSkipConfirmDialog: boolean = false;
	skipCount: number = 0;
	pendingScadenze: Scadenza[] = [];
	types = [
		{ label: 'Seleziona una tipologia', value: null },
		{ label: 'Time & Material', value: 'B' },
		{ label: 'Turnkey', value: 'K' },
		{ label: 'Plafond', value: 'P' },
		{ label: 'Application Maintenance', value: 'A' }
	];
	clientOptions: SelectItem[] = [];

	sortField = 'reforder';
	sortAsc = true;
	minDate: Date = new Date();
	reforder: string | null = null;
	dsofferta: string | null = null;
	idcliente: number | null = null;
	importo: number | null = null;
	giornate: number | null = null;
	dtinizio: Date | null = null;
	dtfine: Date | null = null;
	tipologia: string | null = null;
	dscliente: string | null = null;
	reforderext: string | null = null;
	dtaccettaz: Date | null = null;
	note: string | null = null;
	dora: boolean | null = null;
	cdr: string | null = null;
	linkDocu: string | null = null;
	reforderScadenzeDialog: string | null = null;
	msgs: Message[] = [];
	scadenze: Scadenza[] = [];
	showMsDialog: boolean = false;
	numeroMs: number | null = null;

	importoSommato: number | null = null;


	isClona = false;
	doraOptions = [
		{ label: 'No', value: false },
		{ label: 'Si', value: true },
	];
	tipoServOptions = [
		{ label: " ...", value: null },
		{ label: 'Canoni Servizi web', value: '006' },
		{ label: 'Canoni di Manutenzione', value: '007' },
		{ label: 'Servizi di Sviluppo', value: '008' },
		{ label: 'Servizi di Consulenza', value: '009' },
		{ label: 'Sviluppo Progetti', value: '010' },
	];
	doraFileterOptions = [
		{ label: '...', value: null },
		{ label: 'No', value: "N" },
		{ label: 'Si', value: "S" },
	];

	commesseOptions: SelectItem[] = [];
	commesseFiltered: SelectItem[] = [];

	constructor(
		protected authAccess: AuthAccessProvider,
		protected router: Router,
		protected messageProvider: MessageProvider,
		private userService: UserService,
		private busyProvider: BusyProvider,
		private offerService: OfferService,
		private clientService: ClientService,
		private scadenzeService: ScadenzeFatturazioneService,
	) {
		super(authAccess, router, messageProvider);
		this.messageProvider.clearAll();

	}

	ngOnInit() {

		this.userContext = this.authAccess.getUserContext();

		if (this.userContext == null) {
			this.authAccess.invalidate();
		} else {
			this.loadClients();
			this.loadOffers();
			this.loadUsers();
			this.loadOfferteUtenti();

			this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
				(result) => {
					this.userInfo = result;
				},
				(error) => {
					this.handleError(error);
				}
			);
		}
	}

	loadOffers() {
		this.offers = [];
		this.loading = true;
		if (this.onlyActive) {
			this.filterDtinizio = null;
			this.filterDtfine = null;
		}
		this.filterId = null;
		for (let c of this.clients) {
			if (c.dscliente === this.filterCliente) {
				this.filterId = c.idcliente;
				break;
			}
		}
		this.offerService.getOffers(this.userContext.srmToken, this.onlyActive, this.filterId, this.filterTipologia, this.filterDtinizio, this.filterDtfine, this.filterUser, this.filterRefOrder, this.filterDora, this.filterTipoServ).subscribe(
			(result) => {
				if (result.message) {
					try {
						const offers = JSON.parse(result.message);
						this.offers = offers;
						this.sort(this.sortField, this.sortAsc);
						if (this.offerSelected != null && this.offerSelected.idcliente > 0) {
							this.selectOffer(this.offerSelected);
						}
					} catch (e) {
						console.error("Errore nel parsing JSON:", e);
					}
				}
				this.loading = false;
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	loadClients() {
		this.clients = [];
		this.loading = true;
		this.clientService.getClients(this.userContext.srmToken, false).subscribe(
			(result) => {

				if (result.message) {
					try {
						const clients = JSON.parse(result.message);
						this.clients = clients;

						if (this.clients && this.clients.length > 0) {
							this.clientOptions = [{ label: "", value: null }].concat(this.clients				//ordine alfabetico dei clienti nel dropdown
								.map(client => ({
									label: client.dscliente,
									value: client.dscliente
								}))
								.sort((a, b) => a.label.localeCompare(b.label, 'it', { sensitivity: 'base' })));
						}

					} catch (e) {
						console.error("Errore nel parsing JSON:", e);
					}
				}
				this.loading = false;
			},
			(error) => {
				console.error("Errore API:", error);
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	loadUsers() {
		this.users = [];
		this.userService.getUsers(this.userContext.srmToken, true, false).
			subscribe(
				result => {
					this.users.push({ label: '', value: null });
					for (let i = 0; i < result.users.length; ++i) {
						const current: User = result.users[i];
						this.users.push({ label: current.username, value: current.id });

					}

				},
				error => {
					this.handleError(error);
				});
	}

	loadOfferteUtenti() {
		this.offerteUtenti = [];
		this.utentiAggiunti = [];
		if (this.canLinkUsers(this.offerSelected.tipologia)) {
			this.offerService.getOfferteUtenti(this.userContext.srmToken, this.reforder).subscribe(
				(response: any) => {
					try {
						const offerteData = JSON.parse(response.message);
						if (Array.isArray(offerteData)) {
							this.offerteUtenti.push({ label: '', value: null });

							for (const current of offerteData) {
								this.offerteUtenti.push({ label: current.reforder, value: current.idutente });
							}

							this.utentiAggiunti = this.getUtentiAggiunti(this.reforder);
							this.filteredUsers = this.users;
						} else {
							console.error('La risposta "message" non è un array valido.');
						}
					} catch (e) {
						console.error('Errore nel parsing della risposta JSON:', e);
					}
				},
				error => {
					this.handleError(error);
				}
			);
		}
	}

	getTipologiaDes(tipologia: string) {
		for (var t in this.types) {
			if (this.types[t].value == tipologia) {
				return this.types[t].label;
			}
		}
		return tipologia;
	}

	canLinkUsers(tipologia: string) {
		return tipologia == 'B' || tipologia == 'P';
	}

	applyFilter() {
		if (this.filterTipologia !== 'B' && this.filterTipologia !== 'P') {
			this.filterUser = null;
		}
		this.loadOffers();
		this.showFilter = false;
	}

	removeFilter() {
		this.resetFilter();
		this.loadOffers();
		this.showFilter = false;
	}

	resetFilter() {
		this.filterCliente = null;
		this.filterTipologia = null;
		this.filterDtfine = null;
		this.filterDtinizio = null;
		this.filterId = null;
		this.filterUser = null;
		this.filterRefOrder = null;
		this.filterDora = null;
		this.filterTipoServ = null;
	}

	sort(field: string, asc?: boolean) {
		if (field === this.sortField && (typeof asc === 'undefined' || asc == !this.sortAsc)) {
			this.offers = this.offers.reverse();
			this.sortAsc = !this.sortAsc;
		} else {
			this.sortField = field;
			this.offers = this.offers.sort((a1, a2) => {
				var res = 0;
				if (this.sortField === 'reforder') {
					res = this.compareStrings(a1.reforder, a2.reforder);
				} else if (this.sortField === 'dsofferta') {
					res = this.compareStrings(a1.dsofferta, a2.dsofferta);
				}
				else if (this.sortField === 'dscliente') {
					res = this.compareStrings(a1.dscliente, a2.dscliente);
				} else if (this.sortField === 'importo') {
					res = a1.importo > a2.importo ? 1 : -1;
				} else if (this.sortField === 'giornate') {
					res = a1.giornate > a2.giornate ? 1 : -1;
				} else if (this.sortField === 'dtinizio') {
					res = this.compareDates(a1.dtinizio, a2.dtinizio);
				} else if (this.sortField === 'dtfine') {
					res = this.compareDates(a1.dtfine, a2.dtfine);
				} else if (this.sortField === 'tipologia') {
					res = this.compareStrings(a1.tipologia, a2.tipologia);
				} else if (this.sortField === 'reforderext') {
					res = this.compareStrings(a1.reforder_EXT, a2.reforder_EXT);
				} else if (this.sortField === 'dtaccettaz') {
					res = this.compareDates(a1.dtaccettaz, a2.dtaccettaz);
				} else if (this.sortField === 'dora') {
					res = this.compareStrings(this.decodificaDora(a1.dora), this.decodificaDora(a2.dora));
				} else if (this.sortField === 'cdr') {
					res = this.compareStrings(a1.cdr, a2.cdr);
				}
				return this.sortAsc ? res : -res;
			});
		}
	}

	private compareStrings(s1: string, s2: string): number {
		return (s1 || '').localeCompare(s2 || '', 'it', { sensitivity: 'base', numeric: true });
	}

	convertTipoServizio(serv: string) {
		switch (serv) {
			case '006': return 'Canoni Servizi web';
			case '007': return 'Canoni di Manutenzione';
			case '008': return 'Servizi di Sviluppo';
			case '009': return 'Servizi di Consulenza';
			case '010': return 'Sviluppo Progetti';
			default: return serv;
		}
	}

	private compareDates(d1: Date, d2: Date) {
		if (!d1 && !d2) {
			return 0;
		} else if (!d1) {
			return -1;
		} else if (!d2) {
			return 1;
		} else {
			return +new Date(d1) - +new Date(d2);
		}
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	storeOffer() {
		this.checkDatiInseriti();
		if (this.validationMessage != null) {
			return;
		}

		for (let c of this.clients) {
			if (c.dscliente === this.dscliente) {
				this.idcliente = c.idcliente;
				break;
			}
		}

		// modifica
		if (this.offerSelected.reforder != null && !this.isClona) {
			this.busyProvider.showBusyIndicator();
			let offer: Offer = this.buildOffer();
			offer.reforder = this.offerSelected.reforder;
			this.offerService.updateOffer(this.userContext.srmToken, offer).subscribe(
				() => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Modifica eseguita correttamente" });
					this.syncUtentiOfferta();
					this.loadOffers();
					this.selectOffer(offer);
				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
		// inserimento
		else {

			this.busyProvider.showBusyIndicator();
			let offer: Offer = this.buildOffer();
			this.offerService.insertOffer(this.userContext.srmToken, offer).subscribe(
				() => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Offerta inserita correttamente" });
					this.syncUtentiOfferta();
					this.selectOffer(offer);
					this.loadOffers();
				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}

	}

	private syncUtentiOfferta() {
		if (this.canLinkUsers(this.tipologia)) {
			this.storeUtenti();
			this.deleteUserOffer();
		} else if (this.utentiAggiunti.length != 0) {
			this.utentiAggiunti = [];
			this.deleteUserOffer();
		}
	}

	checkDatiInseriti() {
		this.messageProvider.clearAll();
		this.validationMessage = null;

		if (this.reforder == null || this.reforder.trim() == "") {
			this.validationMessage = "Inserire il codice dell'ordine";
			return;
		}

		if (this.dscliente == null) {
			this.validationMessage = "Selezionare il cliente";
			return;
		}
		if (this.dsofferta == null || this.dsofferta.trim() == "") {
			this.validationMessage = "Inserire la descrizione dell'offerta";
			return;
		}

		if (this.dtinizio != null && this.dtfine != null && this.dtfine < this.dtinizio) {
			this.validationMessage = "La data di fine deve essere successiva a quella di inizio";
			return;
		}
		if (this.dtinizio == null) {
			this.validationMessage = "Inserire la data di inizio";
			return;
		}

		if (this.tipologia == '') {
			this.validationMessage = "Inserire la tipologia";
			return;
		}

		if (this.importo == null || isNaN(this.importo) || this.importo <= 0) {
			this.validationMessage = "Inserire un importo maggiore di 0";
			return;
		}

		if (this.giornate != null && isNaN(this.giornate)) {
			this.validationMessage = "Inserire un valore numerico di giornate";
			return;
		}

	}

	storeUtenti() {
		for (let id of this.utentiAggiunti) {				//Aggiunge solo gli utenti che non c'erano già
			const isInOfferteUtenti = this.offerteUtenti.some(
				(offer) => offer.value === id && offer.label === this.reforder
			);

			if (!isInOfferteUtenti) {
				let user: SelectItem = { label: this.reforder, value: id };
				this.offerService.insertUser(this.userContext.srmToken, user).subscribe(
					(result) => {
						this.busyProvider.hideBusyIndicator();
						this.msgs = [];
						this.msgs.push({ severity: "success", summary: "OK", detail: "Utente inserito correttamente" });


					},
					(error) => {
						this.busyProvider.hideBusyIndicator();
						this.handleError(error);
					}
				);
			}
		}
	}

	async deleteUserOffer() {
		const utentiDaEliminare = new Set<string>();

		for (let user of this.offerteUtenti) {
			if (user.label === this.reforder && !this.utentiAggiunti.includes(user.value)) {
				utentiDaEliminare.add(user.value);
			}
		}

		if (utentiDaEliminare.size === 0) {
			return;
		}

		try {
			await Promise.all(
				Array.from(utentiDaEliminare).map(userId =>
					this.offerService.deleteUser(this.userContext.srmToken, this.reforder, Number(userId)).toPromise()
				)
			);

			this.msgs = [];
			this.msgs.push({ severity: "success", summary: "OK", detail: "Utenti rimossi correttamente" });

		} catch (error) {
			this.handleError(error);
		}
	}

	buildOffer(): Offer {
		let offer: Offer = new Offer();
		offer.reforder = this.reforder;
		if (this.offerSelected.reforder != null && !this.isClona) {
			offer.reforder = this.offerSelected.reforder;
		}
		offer.dsofferta = this.dsofferta;
		offer.dscliente = this.dscliente;
		offer.idcliente = this.idcliente;
		offer.importo = this.importo;
		offer.tipologia = this.tipologia;
		offer.dtfine = this.dtfine;
		offer.dtinizio = this.dtinizio;
		if (this.giornate != null && Number(this.giornate) != 0) {
			offer.giornate = Number(this.giornate);
		} else {
			offer.giornate = null;
		}
		offer.reforder_EXT = this.reforderext;
		offer.dtaccettaz = this.dtaccettaz;
		offer.note = this.note;
		offer.dora = this.dora ? this.dora : false;
		offer.cdr = this.cdr;
		offer.linkdocu = this.linkDocu;

		return offer;
	}

	checkEliminazioni() {
		let trovato: boolean = false;
		let i = 0;
		while (!trovato && i < this.offerteUtenti.length) {
			let user = this.offerteUtenti[i];

			const isInOfferteUtenti = this.utentiAggiunti.some((offer) => offer === user.value && user.label === this.reforder);

			if (user.label === this.reforder && !isInOfferteUtenti) {
				trovato = true;
			}
			i++;
		}

		if ((this.utentiAggiunti.length != 0 && !this.canLinkUsers(this.tipologia)) || trovato) {
			this.showDeleteUserAlert = true;
		} else {
			this.storeOffer();
		}
	}

	selectOffer(offer: Offer) {
		this.isClona = false;
		this.validationMessage = null;
		this.reforder = offer.reforder;
		this.offerSelected = offer;
		this.dsofferta = this.offerSelected.dsofferta;
		this.dscliente = offer.dscliente;
		this.idcliente = offer.idcliente;
		this.importo = offer.importo;
		if (offer.dtfine != null) {
			this.dtfine = new Date(offer.dtfine);
		}
		else {
			this.dtfine = null;
		}
		if (offer.dtinizio != null) {
			this.dtinizio = new Date(offer.dtinizio);
		}
		else {
			this.dtinizio = null;
		}
		this.tipologia = offer.tipologia;
		if (offer.giornate != null) {
			this.giornate = offer.giornate;
		}
		else {
			this.giornate = null;
		}
		this.reforderext = offer.reforder_EXT;
		if (offer.dtaccettaz != null) {
			this.dtaccettaz = new Date(offer.dtaccettaz);
		}
		else {
			this.dtaccettaz = null;
		}
		this.note = offer.note;
		this.dora = offer.dora;
		this.cdr = offer.cdr;
		this.linkDocu = offer.linkdocu;
		this.loadOfferteUtenti();
	}

	getUtentiAggiunti(reforder: string): number[] {
		const utentiAssociati: number[] = [];
		for (const offerta of this.offerteUtenti) {
			if (offerta.label === reforder) {
				utentiAssociati.push(offerta.value);
			}
		}
		return Array.from(new Set(utentiAssociati));
	}

	getUserLabel(id: number): string {
		const user = this.users.find(u => u.value === id);
		return user ? user.label : 'Utente non trovato';
	}


	addNewOffer() {
		this.validationMessage = null;
		this.messageProvider.clearAll();
		this.offerSelected = new Offer();
		this.reforder = null;
		this.idcliente = null;
		this.dsofferta = null;
		this.importo = null;
		this.dtfine = null;
		this.dtinizio = null;
		this.tipologia = '';
		this.giornate = null;
		this.dscliente = null;
		this.reforderext = null;
		this.dtaccettaz = null;
		this.note = null;
		this.utentiAggiunti = [];
		this.isClona = false;
		this.dora = false;
		this.cdr = null;
		this.linkDocu = null;
	}

	addUser(current) {
		this.utentiAggiunti.push(current.value);
	}

	deleteUser(current) {
		const index = this.utentiAggiunti.indexOf(current.value);
		if (index !== -1) {
			this.utentiAggiunti.splice(index, 1);
		}
	}

	openDeleteAlert(current: Offer) {
		this.selectOffer(current);
		this.showDeleteAlert = true;
	}

	closeDeleteAlert() {
		this.showDeleteAlert = false;
	}

	closeDeleteUserAlert() {
		this.showDeleteUserAlert = false;
	}

	deleteOffer() {
		this.messageProvider.clearAll();
		this.validationMessage = null;

		this.busyProvider.showBusyIndicator();
		this.offerService.deleteOffer(this.userContext.srmToken, this.reforder).subscribe(
			result => {
				this.busyProvider.hideBusyIndicator();
				this.msgs = [];
				this.msgs.push({ severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente' });
				this.utentiAggiunti = [];
				this.addNewOffer();
				this.loadOffers();
			},
			error => {
				this.busyProvider.hideBusyIndicator();
				this.handleError(error);
			});
	}

	gestisciUtenti() {
		if (this.reforder != null && this.reforder.trim() != "") {
			this.filterQuery = "";
			this.filteredUsers = this.users;
			this.showUsersDialog = true;
		} else {
			this.validationMessage = "Inserire il codice dell'ordine prima di aggiungere utenti";
		}
	}

	filterUsers() {
		this.filteredUsers = this.users;
		if (this.filterQuery != null && this.filterQuery.trim() != "") {
			this.filteredUsers = [];
			for (let i = 0; i < this.users.length; ++i) {
				let dsutente = this.users[i].label;
				let filterQuery = this.filterQuery;
				if ((dsutente && filterQuery && dsutente.toLowerCase().indexOf(filterQuery.toLowerCase()) >= 0)) {
					this.filteredUsers.push(this.users[i]);
				}
			}
		}
	}

	aggiorna() {
		this.loadOffers();
		this.loadClients();
		this.loadOfferteUtenti();
		this.loadUsers();
	}

	aggiornaClienti() {
		this.loadClients();
	}

	closeGeneraScadenzaAlert() {
		this.showGeneraScadenzaAlert = false;
	}

	onScadenzaDialogHide() {
		this.scadenze = [];
		this.validationMessageScadenzaAlert = null;
	}

	closeGeneraScadenzeErrorDialog() {
		this.showGeneraScadenzeErrorDialog = false;
		this.generaScadenzeErrorMessage = null;
	}

	openGeneraScadenzaAlert() {
		this.scadenze = [];
		this.checkDatiInseriti();

		if (this.validationMessage != null) {
			this.generaScadenzeErrorMessage = this.validationMessage;
			this.validationMessage = null;
			this.showGeneraScadenzeErrorDialog = true;
			return;
		}

		if (this.dtinizio == null || this.dtfine == null) {
			this.generaScadenzeErrorMessage = "Inserire le date di inizio e di fine";
			this.showGeneraScadenzeErrorDialog = true;
			return;
		}

		this.reforderScadenzeDialog = this.reforder;


		//tipologia = application manteinence
		if (this.tipologia == 'A') {
			this.importoSommato = 0;
			//acconto
			let scadenzaAcconto = new Scadenza();
			scadenzaAcconto.dsscad = (this.offerSelected.dscliente && this.offerSelected.dscliente.startsWith('CSE') ? this.getIntestazioneDescrizione(this.offerSelected.reforder_EXT, this.offerSelected.reforder) : "") + " " + this.dsofferta + " Acconto";
			scadenzaAcconto.dtscad = this.dtaccettaz;
			scadenzaAcconto.importo = this.importo / 2;
			this.importoSommato += scadenzaAcconto.importo;
			scadenzaAcconto.reforder = this.reforder;
			this.scadenze.push(scadenzaAcconto);

			//saldo
			let scadenzaSaldo = new Scadenza();
			scadenzaSaldo.dsscad = (this.offerSelected.dscliente && this.offerSelected.dscliente.startsWith('CSE') ? this.getIntestazioneDescrizione(this.offerSelected.reforder_EXT, this.offerSelected.reforder) : "") + " " + this.dsofferta + " Saldo";
			scadenzaSaldo.dtscad = this.calculateDataFattTypeA(this.dtinizio, this.dtfine);
			scadenzaSaldo.importo = this.importo / 2;
			this.importoSommato += scadenzaSaldo.importo;
			scadenzaSaldo.reforder = this.reforder;
			this.scadenze.push(scadenzaSaldo);

			//visualizziamo la dialog scadenze
			this.showGeneraScadenzaAlert = true;
			//togliamo la visualizzazione della dialog per l'inseirmnto ms
			this.showMsDialog = false;
		}

		//tipologia = time and material
		if (this.tipologia == 'B') {
			this.importoSommato = 0;
			let dataInizio = new Date(this.dtinizio);
			let dataFine = new Date(this.dtfine);
			let dateIntervallo: Date[] = this.getDatesFromInterval(dataInizio, dataFine);
			let numIntervalli = dateIntervallo.length;

			dateIntervallo.forEach(dataFineMese => {
				const meseNumero = dataFineMese.getMonth() + 1;
				const mese = meseNumero < 10 ? '0' + meseNumero : meseNumero.toString();

				let scadenzaTypeB = new Scadenza();
				scadenzaTypeB.dsscad = (this.offerSelected.dscliente && this.offerSelected.dscliente.startsWith('CSE') ? this.getIntestazioneDescrizione(this.offerSelected.reforder_EXT, this.offerSelected.reforder) : "") + " " + `${this.dsofferta} - ${mese}/${dataFineMese.getFullYear()}`;
				scadenzaTypeB.dtscad = dataFineMese;
				scadenzaTypeB.importo = this.importo / numIntervalli;
				scadenzaTypeB.reforder = this.reforder;
				this.importoSommato += scadenzaTypeB.importo;

				this.scadenze.push(scadenzaTypeB);
			});
			this.showGeneraScadenzaAlert = true;
			this.showMsDialog = false;
		}

		//tipologia = turnkey: si chiede prima il numero di MS via dialog dedicata
		if (this.tipologia == 'K') {
			this.numeroMs = null;
			this.showMsDialog = true;
		}
	}

	cancelMsDialog() {
		this.showMsDialog = false;
		this.numeroMs = null;
	}

	confirmMsAndGenerate() {
		if (this.numeroMs == null || this.numeroMs < 1) {
			return;
		}
		this.scadenze = [];
		this.importoSommato = 0;
		//acconto
		let scadenzaAcconto = new Scadenza();
		scadenzaAcconto.dsscad = (this.offerSelected.dscliente && this.offerSelected.dscliente.startsWith('CSE') ? this.getIntestazioneDescrizione(this.offerSelected.reforder_EXT, this.offerSelected.reforder) : "") + " " + this.dsofferta + " Acconto";
		scadenzaAcconto.dtscad = this.dtaccettaz;
		scadenzaAcconto.importo = this.importo * 0.20;
		scadenzaAcconto.reforder = this.reforder;
		this.importoSommato += scadenzaAcconto.importo;
		this.scadenze.push(scadenzaAcconto);

		//milestones: importo al netto di acconto e saldo accettazione: 20%, saldo 5%, MS il rimanente diviso il n. di MS.
		let netto = this.importo - (this.importo * 0.05 + this.importo * 0.20);
		for (let i = 0; i < this.numeroMs; i++) {
			let scadenzaTypeK = new Scadenza();
			scadenzaTypeK.dsscad = (this.offerSelected.dscliente && this.offerSelected.dscliente.startsWith('CSE') ? this.getIntestazioneDescrizione(this.offerSelected.reforder_EXT, this.offerSelected.reforder) : "") + " " + this.dsofferta + " MS" + (i + 1);
			scadenzaTypeK.importo = netto / this.numeroMs;
			this.importoSommato += scadenzaTypeK.importo;
			scadenzaTypeK.reforder = this.reforder;
			this.scadenze.push(scadenzaTypeK);
		}

		//saldo
		let scadenzaSaldo = new Scadenza();
		scadenzaSaldo.dsscad = (this.offerSelected.dscliente && this.offerSelected.dscliente.startsWith('CSE') ? this.getIntestazioneDescrizione(this.offerSelected.reforder_EXT, this.offerSelected.reforder) : "") + " " + this.dsofferta + " Saldo";
		scadenzaSaldo.dtscad = new Date(this.dtfine);
		scadenzaSaldo.dtscad.setDate(this.dtfine.getDate() + 30);
		scadenzaSaldo.importo = this.importo * 0.05;
		this.importoSommato += scadenzaSaldo.importo;
		scadenzaSaldo.reforder = this.reforder;
		this.scadenze.push(scadenzaSaldo);

		this.showMsDialog = false;
		this.showGeneraScadenzaAlert = true;
	}

	calcolaGiornate(importoScadenza: number, ggOfferta: number) {
		return this.importo / ggOfferta * importoScadenza;
	}

	generaScadenze() {
		this.validationMessageScadenzaAlert = null;

		for (let s of this.scadenze) {
			const hasDati = s.dtscad != null || (s.importo != null && s.importo > 0);
			if (hasDati && (s.dsscad == null || s.dsscad.trim() === '')) {
				this.validationMessageScadenzaAlert = "Inserire la descrizione";
				return;
			}
		}

		const righeVuote = this.scadenze.filter(s => s.dtscad == null && (s.importo == null || s.importo <= 0));
		if (righeVuote.length > 0) {
			this.skipCount = righeVuote.length;
			this.pendingScadenze = this.scadenze.filter(s => !(s.dtscad == null && (s.importo == null || s.importo <= 0)));
			this.showSkipConfirmDialog = true;
			return;
		}

		for (let s of this.scadenze) {
			if (s.dtscad == null) {
				this.validationMessageScadenzaAlert = "Inserire la data di scadenza";
				return;
			}
			if (s.importo == null || s.importo <= 0) {
				this.validationMessageScadenzaAlert = "Inserire l'importo";
				return;
			}
		}

		this.doStoreScadenze(this.scadenze);
	}

	confirmSkipAndStore() {
		this.showSkipConfirmDialog = false;
		this.doStoreScadenze(this.pendingScadenze);
		this.pendingScadenze = [];
	}

	cancelSkipConfirm() {
		this.showSkipConfirmDialog = false;
		this.pendingScadenze = [];
		this.skipCount = 0;
	}

	private doStoreScadenze(scadenze: Scadenza[]) {
		this.storeScadenza(scadenze);
		this.scadenze = [];
		this.showGeneraScadenzaAlert = false;
	}

	calculateDataFattTypeA(dataInizio: Date, dataFine: Date): Date {
		const startTime = dataInizio.getTime();
		const endTime = dataFine.getTime();

		const metaTime = startTime + (endTime - startTime) / 2;
		const dataMeta = new Date(metaTime);

		return new Date(
			dataMeta.getFullYear(),
			dataMeta.getMonth() + 1,
			1
		);
	}

	getDatesFromInterval(
		dataInizio: Date,
		dataFine: Date
	): Date[] {
		const result: Date[] = [];

		let current = new Date(
			dataInizio.getFullYear(),
			dataInizio.getMonth(),
			1
		);

		while (current <= dataFine) {
			const fineMese = new Date(
				current.getFullYear(),
				current.getMonth() + 1,
				0
			);

			result.push(fineMese);

			// Passiamo al mese successivo
			current = new Date(
				current.getFullYear(),
				current.getMonth() + 1,
				1
			);
		}

		return result;
	}

	storeScadenza(scadenze: Scadenza[]) {
		const total = scadenze.length;
		if (total === 0) {
			return;
		}
		let inseriteOk = 0;
		this.busyProvider.showBusyIndicator();
		Observable.from(scadenze)
			.concatMap(scadenzaDaInserire =>
				this.scadenzeService.insertScadenza(this.userContext.srmToken, scadenzaDaInserire)
					.do(() => { inseriteOk++; })
					.catch(error => {
						this.handleError(error);
						return Observable.of(null);
					})
			)
			.subscribe(
				null,
				null,
				() => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					if (inseriteOk === total) {
						this.msgs.push({ severity: "success", summary: "OK", detail: `${inseriteOk} scadenze inserite correttamente` });
					} else if (inseriteOk > 0) {
						this.msgs.push({ severity: "warn", summary: "Parziale", detail: `${inseriteOk} di ${total} scadenze inserite` });
					}
				}
			);
	}

	filterOffer(event) {
		this.caricaSuggerimentiCommesse();
		this.commesseFiltered = AppConstants.filterSuggestions(this.commesseOptions, event.query, item => [item.label, item.value]);
	}

	onSelectOffer(event) {
		if (event && typeof event === 'object' && event.value) {
			this.filterRefOrder = event.value;
		}
	}

	caricaSuggerimentiCommesse() {
		this.commesseOptions = this.offers				//ordine alfabetico dei clienti nel dropdown
			.map(offer => ({
				label: offer.dsofferta,
				value: offer.reforder
			}))
			.sort((a, b) => a.label.localeCompare(b.label, 'it', { sensitivity: 'base' }));
	}

	openClone(event: MouseEvent, offer) {
		event.stopPropagation();
		this.selectOffer(offer);
		this.isClona = true;
		this.reforder = null;
		this.reforderext = null;
		this.dtaccettaz = null;
		this.linkDocu = null;
	}

	decodificaDora(dora: boolean): string | null {
		if (dora != null && dora) {
			return "Sì";
		}
		return "No";
	}

	onDateSelected(event: Date) {
		this.onlyActive = false;
	}

	getIntestazioneDescrizione(refOrderExt: string | null, reforder: string | null): string {
		const ext = (refOrderExt != null && refOrderExt.trim() !== '') ? refOrderExt : "N/D";
		const ref = (reforder != null && reforder.trim() !== '') ? reforder : "N/D";
		return "Prot.Gen. " + ext + " (Rif " + ref + ")";
	}

	ricalcolaImportoSommato() {
		this.importoSommato = 0;
		for (let s of this.scadenze) {
			if (s.importo != null) {
				this.importoSommato += s.importo;
			}
		}
	}

    formatImporto(value: any): string {
        if (value == null || value === '') return '';
        const num = Number(value);
        if (isNaN(num)) return '';
        return num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}



// WEBPACK FOOTER //
// ./src/app/offers/offers.component.ts